import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.emailCreateEditState || initialState;

export const selectCreateEditEmailTemplate = createSelector(
  [selectDomain],
  emailCreateEditState => emailCreateEditState.emailTemplate,
);

export const selectSavedEmailTemplate = createSelector(
  [selectDomain],
  emailCreateEditState => emailCreateEditState.savedEmailTemplate,
);